// Template function.
export const template = (str, vars) => {
	return str.replace(/{{([^}]+)}}/g, function(match, property) {
		var arr = property.split('.');
		var obj = vars[arr.shift()];

		while (arr.length > 0 && typeof obj === 'object') {
			obj = obj[arr.shift()];
		}

		return typeof obj === 'undefined' ? match : obj;
	});
}

export const fetchData = src => {
	return $.ajax({
		url: src,
		type: 'GET',
		dataType: 'json'
	});
}



// WEBPACK FOOTER //
// ../src/assets/js/utils/index.js